import { useState } from "react";
import { FilterGroup, FilterOption, FilterSidebar, TextInput } from "@amber/ui";
import { FACETS, FACET_TITLES, type Facet, type FacetOption } from "./rosterFilters";

function FacetGroup({
  facet,
  options,
  selected,
  counts,
  onToggle,
}: {
  facet: Facet;
  options: readonly FacetOption[];
  selected: ReadonlySet<string>;
  counts: ReadonlyMap<string, number>;
  onToggle: (facet: Facet, key: string) => void;
}) {
  const [find, setFind] = useState("");
  const needle = find.trim().toLowerCase();
  const shown =
    facet === "person"
      ? options.filter((o) => !needle || selected.has(o.key) || o.label.toLowerCase().includes(needle))
      : options;
  return (
    <FilterGroup title={FACET_TITLES[facet]}>
      {facet === "person" ? (
        <>
          <label className="sr-only" htmlFor="roster-find-person">
            Find a person
          </label>
          <TextInput
            id="roster-find-person"
            type="search"
            placeholder="Find a person"
            className="mb-1 h-7"
            value={find}
            onChange={(e) => {
              setFind(e.target.value);
            }}
          />
        </>
      ) : null}
      {shown.map((o) => (
        <FilterOption
          key={o.key}
          type="checkbox"
          name={`profile-${facet}`}
          checked={selected.has(o.key)}
          label={o.label}
          count={counts.get(o.key) ?? 0}
          onChange={() => {
            onToggle(facet, o.key);
          }}
        />
      ))}
    </FilterGroup>
  );
}

export function RosterSidebar({
  open,
  options,
  selected,
  counts,
  onToggle,
}: {
  open: boolean;
  options: Record<Facet, readonly FacetOption[]>;
  selected: Record<Facet, ReadonlySet<string>>;
  counts: Record<Facet, ReadonlyMap<string, number>>;
  onToggle: (facet: Facet, key: string) => void;
}) {
  return (
    <FilterSidebar label="Profile filters" open={open}>
      {FACETS.filter((f) => options[f].length > 0).map((facet) => (
        <FacetGroup
          key={facet}
          facet={facet}
          options={options[facet]}
          selected={selected[facet]}
          counts={counts[facet]}
          onToggle={onToggle}
        />
      ))}
    </FilterSidebar>
  );
}
